import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneSelect } from '@yy/one-ui'
import type { IOneSelectProps } from '@yy/one-ui/lib/OneSelect'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import { CONSIGNEE_CERTTIFICATE_TYPE } from '../../../../enum'
import RULES from '../../../../rules'

const { Option } = OneSelect

interface IProps extends IOneSelectProps<any> {
  required?: boolean
  consigneeIdTypeOpt?: {
    label: string
    value: any
  }[]
}

/** 证件类型信息 */
export const consigneeCertificateTypeOption = [
  {
    label: 'logistics.create.idCard',
    value: CONSIGNEE_CERTTIFICATE_TYPE.idCard,
  },
  {
    label: 'logistics.create.passport',
    value: CONSIGNEE_CERTTIFICATE_TYPE.passport,
  },
  {
    label: 'provider.consigneeIdType.ghPass',
    value: CONSIGNEE_CERTTIFICATE_TYPE.ghPass,
  },
  {
    label: 'provider.consigneeIdType.hxPass',
    value: CONSIGNEE_CERTTIFICATE_TYPE.hxPass,
  },
  {
    label: 'provider.consigneeIdType.tbPass',
    value: CONSIGNEE_CERTTIFICATE_TYPE.tbPass,
  },
  {
    label: 'provider.consigneeIdType.twPass',
    value: CONSIGNEE_CERTTIFICATE_TYPE.twPass,
  },
  {
    label: 'provider.consigneeIdType.other',
    value: CONSIGNEE_CERTTIFICATE_TYPE.other,
  },
]

const Select: React.FC<Omit<IProps, 'required'>> = (props) => {
  const { consigneeIdTypeOpt, ...args } = props
  const { t } = useTranslation()

  return (
    <OneSelect {...args} allowClear>
      {(consigneeIdTypeOpt || consigneeCertificateTypeOption).map((item) => (
        <Option key={item.value} value={item.value}>
          {t(item.label)}
        </Option>
      ))}
    </OneSelect>
  )
}

const ConsigneeIdTypeField: FC<IProps> = (props) => {
  const { required = false, defaultValue, consigneeIdTypeOpt, ...args } = props

  const { t } = useTranslation()

  return (
    <FormItem
      initialValue={defaultValue}
      required={required}
      name="provider_consignee_id_type"
      label={t('logistics.create.cardType')}
      rules={RULES.provider_consignee_id_type({
        isRequired: required,
      })}
    >
      <Select consigneeIdTypeOpt={consigneeIdTypeOpt} placeholder={t('common.select.placeholder')} {...args} />
    </FormItem>
  )
}

export default ConsigneeIdTypeField
